import { Redirect, generatePath, matchPath, useLocation } from 'quartz-routing/react-router';
import { MYLEARNING_URL_FRAGMENT, LEGACY_MYLEARNING_URL_FRAGMENT } from '../../constants/Navigation';
import { MY_LEARNING_TABS } from './myLearningTypes';
import { FILTER_TYPES } from '../../constants/TopFilterConstants';
import { jsx as _jsx } from "react/jsx-runtime";
const legacyMyLearningTabs = MY_LEARNING_TABS.join('|');
export const getMyLearningUrl = () => {
  return generatePath(MYLEARNING_URL_FRAGMENT);
};
const useConvertLegacyTabToSearchFilter = () => {
  const {
    pathname,
    search
  } = useLocation();
  const urlSearchParams = new URLSearchParams(search);
  const match = matchPath(pathname, {
    path: `${LEGACY_MYLEARNING_URL_FRAGMENT}/:tab(${legacyMyLearningTabs})?`
  });
  if (!match) {
    return `?${urlSearchParams.toString()}`;
  }
  const {
    tab
  } = match.params;
  switch (tab) {
    case 'courses-and-lessons':
      {
        urlSearchParams.set(FILTER_TYPES.CONTENT_TYPE, 'COURSE');
        urlSearchParams.append(FILTER_TYPES.CONTENT_TYPE, 'LESSON');
        break;
      }
    case 'playlists':
      {
        urlSearchParams.set(FILTER_TYPES.CONTENT_TYPE, 'LEARNING_PATH');
        break;
      }
    case 'videos':
      {
        urlSearchParams.set(FILTER_TYPES.CONTENT_TYPE, 'SHORT_FORM_CONTENT');
        break;
      }
    default:
      {
        urlSearchParams.delete(FILTER_TYPES.CONTENT_TYPE);
        break;
      }
  }
  return `?${urlSearchParams.toString()}`;
};
export const RedirectToMyLearning = () => {
  const search = useConvertLegacyTabToSearchFilter();
  const location = useLocation();
  const {
    pathname
  } = location;
  return /*#__PURE__*/_jsx(Redirect, {
    to: Object.assign({}, location, {
      pathname: pathname.replace(new RegExp(`${LEGACY_MYLEARNING_URL_FRAGMENT}(/(${legacyMyLearningTabs}))?`), MYLEARNING_URL_FRAGMENT),
      search
    })
  });
};